import XesAxios from './XesAxios'
import envConfig from './config'
import qs from 'qs'
const { env, mock, baseApi, mockApi } = envConfig

let BASE_URL = ''
if (env === 'production') {
  BASE_URL = baseApi
} else {
  BASE_URL = mock ? mockApi : baseApi
}

export default {
  // 活动报名
  apply(params) {
    return XesAxios.post(`${BASE_URL}/activity/apply`, params)
  },
  // 用户征文列表
  getPersonallist() {
    return XesAxios.get(`${BASE_URL}/artical/personallist?v=${+new Date()}`)
  },
  // 征文详情
  getArticleDetail(params) {
    return XesAxios.get(`${BASE_URL}/artical/detail`, {
      params
    })
  },
  // 获取年级列表
  getGradeList() {
    return XesAxios.get(`${BASE_URL}/activity/gradelist`)
  },
  // 获取小程序二维码
  getWxAppCode(params) {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/getWxAppCode', params)
  },
  // 点赞
  thumb(params) {
    return XesAxios.post(`${BASE_URL}/artical/thumb`, params)
  },
  // 绑定物流地址
  bindAddress(params) {
    return XesAxios.post(
      'https://booster.xueersi.com/h5EditStation/OperationDraw/AddOtmsByAddress',
      qs.stringify(params),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    )
  },
  // 绑定物流单号
  addOtmsNumber(params) {
    return XesAxios.post(`${BASE_URL}/artical/otms/add`, params)
  },
  // 获取收货地址信息
  addrInfos() {
    return XesAxios.get('https://account.xueersi.com/Profile/addrInfos')
  },
  // 添加地址
  addrMod(params) {
    return XesAxios.post('https://account.xueersi.com/Profile/addrMod', qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  },
  // // 添加地址
  // addAddress(rewardId, info) {
  //   return XesAxios.post(`${BASE_URL}/motherDay/addAddress`, qs.stringify({ rewardId, info }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  // },
  // 查询地址
  getAddressInfo(orderNum) {
    return XesAxios.post(
      'https://booster.xueersi.com/accTzTzBigBuy/getAddressInfo',
      qs.stringify({ orderNum }),
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    )
  },
  // 分享关系绑定
  appCodeBind(params) {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/appCodeBind', params)
  }
}
